import { createGlobalStyle } from 'styled-components';
import { colorBlue, colorBlueHover, colorText, colorAdditional, colorAccent, colorWhite, colorRed, colorBackgroundBody, scrollbarStyles } from '@spark/ui-components/theme';
import { left, borderLeft, paddingLeft } from '@spark/ui-components/theme';
import { fontFamily, fontWeight, fontSize, lineHeight, letterSpacing, textStyles, applyTextStyle } from '@spark/ui-components/theme';
const GlobalStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }
  
  main {
    padding: 0;
  }

  body {
    margin: 0;
    padding: 0 !important;
    box-sizing: border-box;
    font-family: ${fontFamily.primary};
    font-size: ${fontSize.base};
    line-height: ${lineHeight.relaxed};
    font-weight: ${fontWeight.regular};
    letter-spacing: ${letterSpacing.normal};
    color: ${colorText};
  }

  .row > * {
    padding: 0 15px;
  }

  * {
    box-sizing: inherit;
  }

  ul, ol {
    // doesn't do RTL, it break a sidebar
    padding-left: 15px;
    margin-bottom: 0;
    list-style-image: url(${process.env.PUBLIC_URL}/img/circle.svg);
  }

  a {
    color: ${colorBlue};
    transition: all 0.3s;
    text-decoration: none;
    font-family: ${fontFamily.primary};
    font-weight: ${fontWeight.medium};

    &:hover {
      color: ${colorBlueHover};
    }
  }

  button:focus, button:active {
    outline: none;
  }

  img {
    width: 100%;
  }

  label {
    margin-bottom: 8px;
    font-family: ${fontFamily.primary};
    font-weight: ${fontWeight.medium};
    font-size: ${fontSize.sm};
    line-height: ${lineHeight.normal};
    letter-spacing: ${letterSpacing.normal};
  }

  // TIPOGRAFIA PADRONIZADA
  p, h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 0;
    color: ${colorText};
    font-family: ${fontFamily.primary};
  }

  p {
    ${applyTextStyle('body')}
    margin-bottom: 1rem;
  }

  h1 {
    ${applyTextStyle('h1')}
    margin-bottom: 1.5rem;
    
    &.subhead {
      font-size: ${fontSize['5xl']};
      color: ${colorAdditional};
      line-height: ${lineHeight.tight};
      font-weight: ${fontWeight.medium};
    }
  }

  h2 {
    ${applyTextStyle('h2')}
    margin-bottom: 1.25rem;
    
    &.subhead {
      font-size: ${fontSize['4xl']};
      color: ${colorAdditional};
      line-height: ${lineHeight.snug};
      font-weight: ${fontWeight.medium};
    }
  }

  h3 {
    ${applyTextStyle('h3')}
    margin-bottom: 1rem;
    
    &.subhead {
      font-size: ${fontSize['3xl']};
      color: ${colorAdditional};
      line-height: ${lineHeight.normal};
      font-weight: ${fontWeight.medium};
    }
  }

  h4 {
    ${applyTextStyle('h4')}
    margin-bottom: 0.875rem;
    
    &.subhead {
      font-size: ${fontSize.sm};
      color: ${colorAdditional};
      line-height: ${lineHeight.normal};
      font-weight: ${fontWeight.regular};
    }
  }

  h5 {
    ${applyTextStyle('h5')}
    margin-bottom: 0.75rem;
    
    &.subhead {
      font-size: ${fontSize.xs};
      color: ${colorAdditional};
      line-height: ${lineHeight.normal};
      font-weight: ${fontWeight.regular};
    }
  }

  h6 {
    ${applyTextStyle('h6')}
    margin-bottom: 0.625rem;
    
    &.subhead {
      font-size: ${fontSize.xs};
      color: ${colorAdditional};
      line-height: ${lineHeight.normal};
      font-weight: ${fontWeight.regular};
    }
  }
  
  hr {
    opacity: 0.1;
  }
  
  .table-responsive {
    ${scrollbarStyles};
  }
  
  blockquote {
    font-size: ${fontSize.base};
    font-style: italic;
    font-family: ${fontFamily.primary};
    line-height: ${lineHeight.relaxed};
    ${borderLeft}: 3px solid ${colorAccent};
    margin-bottom: 0;
    text-align: ${left};
    ${paddingLeft}: 10px;
  }

  .highlight {
    background-color: ${colorAccent};
    color: ${colorWhite};
  }

  .typography-message{
    text-align: ${left};
    font-family: ${fontFamily.primary};
  }

  .red-text {
    color: ${colorRed};
  }

  .page-title {
    text-align: ${left};
    font-weight: ${fontWeight.medium};
    text-transform: capitalize;
    font-size: ${fontSize['2xl']};
    font-family: ${fontFamily.primary};
    line-height: ${lineHeight.normal};
    letter-spacing: ${letterSpacing.normal};

    &:last-child {
      margin-bottom: 30px;
    }

    &.page-title--not-last {
      margin-top: 20px;
    }
  }

  .page-subhead {
    text-align: ${left};
    margin-bottom: 20px;
    font-family: ${fontFamily.primary};

    &.subhead {
      font-size: ${fontSize.sm};
      opacity: 0.7;
      font-weight: ${fontWeight.regular};
      line-height: ${lineHeight.normal};
    }
  }

  // Classes utilitárias de tipografia
  .text-xs { font-size: ${fontSize.xs}; }
  .text-sm { font-size: ${fontSize.sm}; }
  .text-base { font-size: ${fontSize.base}; }
  .text-lg { font-size: ${fontSize.lg}; }
  .text-xl { font-size: ${fontSize.xl}; }
  .text-2xl { font-size: ${fontSize['2xl']}; }
  .text-3xl { font-size: ${fontSize['3xl']}; }
  .text-4xl { font-size: ${fontSize['4xl']}; }
  .text-5xl { font-size: ${fontSize['5xl']}; }
  .text-6xl { font-size: ${fontSize['6xl']}; }

  .font-light { font-weight: ${fontWeight.light}; }
  .font-normal { font-weight: ${fontWeight.regular}; }
  .font-medium { font-weight: ${fontWeight.medium}; }
  .font-semibold { font-weight: ${fontWeight.semibold}; }
  .font-bold { font-weight: ${fontWeight.bold}; }
  .font-extrabold { font-weight: ${fontWeight.extrabold}; }

  .leading-none { line-height: ${lineHeight.none}; }
  .leading-tight { line-height: ${lineHeight.tight}; }
  .leading-snug { line-height: ${lineHeight.snug}; }
  .leading-normal { line-height: ${lineHeight.normal}; }
  .leading-relaxed { line-height: ${lineHeight.relaxed}; }
  .leading-loose { line-height: ${lineHeight.loose}; }

  .tracking-tighter { letter-spacing: ${letterSpacing.tighter}; }
  .tracking-tight { letter-spacing: ${letterSpacing.tight}; }
  .tracking-normal { letter-spacing: ${letterSpacing.normal}; }
  .tracking-wide { letter-spacing: ${letterSpacing.wide}; }
  .tracking-wider { letter-spacing: ${letterSpacing.wider}; }
  .tracking-widest { letter-spacing: ${letterSpacing.widest}; }

  ::selection {
    color: ${colorWhite};
    background: ${colorAccent};
  }

  .first-letter-uppercase:first-letter {
    text-transform: uppercase;
  }

  .container {

    @media screen and (min-width: 768px) {
      width: 100%;
      max-width: 1630px;
    }
  }


  .rc-slider-tooltip {
    padding-bottom: 2px;

    .rc-slider-tooltip-inner {
      margin-bottom: 5px;
      background-color: ${colorBackgroundBody};
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
      color: ${colorText};
      font-size: ${fontSize.xs};
      line-height: ${lineHeight.normal};
      padding: 4px 4px;
      height: 20px;
      min-width: 28px;
      border-radius: 0;
      font-family: ${fontFamily.primary};
    }

    &.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
      border-top-color: ${colorBackgroundBody};
    }

    &.rc-slider-tooltip-hidden {
      display: block;
    }
  }`;
export default GlobalStyles;
